const GLYPHS = {
  Aries: (
    <>
      <path d="M8 4C5 4 4 7 6 9c1.2 1.2 3 .8 4-.5" />
      <path d="M16 4c3 0 4 3 2 5-1.2 1.2-3 .8-4-.5" />
      <line x1="12" y1="8" x2="12" y2="20" />
    </>
  ),
  Taurus: (
    <>
      <circle cx="12" cy="15" r="5" />
      <path d="M6 6c0 3 2.5 5 6 5s6-2 6-5" />
    </>
  ),
  Gemini: (
    <>
      <line x1="7" y1="4" x2="17" y2="4" />
      <line x1="7" y1="20" x2="17" y2="20" />
      <line x1="9" y1="4" x2="9" y2="20" />
      <line x1="15" y1="4" x2="15" y2="20" />
    </>
  ),
  Cancer: (
    <>
      <path d="M6 9c0 4 3 6 6 6" />
      <path d="M18 15c0-4-3-6-6-6" />
      <circle cx="6" cy="15" r="2" />
      <circle cx="18" cy="9" r="2" />
    </>
  ),
  Leo: (
    <>
      <circle cx="9" cy="9" r="4" />
      <path d="M9 13v4c0 2 2 3 4 2s2-3 0-4" />
    </>
  ),
  Virgo: (
    <>
      <path d="M5 4v14M9 4v10M13 4v10M17 4c2 4 0 8-3 10 2 1 3-1 3-3" />
    </>
  ),
  Libra: (
    <>
      <path d="M6 12c0-4 3-6 6-6s6 2 6 6" />
      <line x1="4" y1="16" x2="20" y2="16" />
      <line x1="4" y1="20" x2="20" y2="20" />
    </>
  ),
  Scorpio: (
    <>
      <path d="M5 4v14M9 4v14M13 4v14M17 4v11l3 3M17 12l3-3" />
    </>
  ),
  Sagittarius: (
    <>
      <line x1="5" y1="19" x2="19" y2="5" />
      <polyline points="12,5 19,5 19,12" />
      <line x1="10" y1="10" x2="14" y2="14" />
    </>
  ),
  Capricorn: (
    <>
      <path d="M5 4c0 6 2 10 5 10s4-3 3-5" />
      <path d="M13 9c2 0 3 2 3 4 0 3-2 5-2 8" />
      <circle cx="17" cy="18" r="1.5" />
    </>
  ),
  Aquarius: (
    <>
      <path d="M3 9l4-2 4 2 4-2 4 2 4-2" />
      <path d="M3 16l4-2 4 2 4-2 4 2 4-2" />
    </>
  ),
  Pisces: (
    <>
      <path d="M8 4C5 8 5 16 8 20" />
      <path d="M16 4c3 4 3 12 0 16" />
      <line x1="4" y1="12" x2="20" y2="12" />
    </>
  ),
}

export default function ZodiacGlyph({ sign, className, ...rest }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      {GLYPHS[sign]}
    </svg>
  )
}
